import { imgSrc } from "@/lib/categories";

export function Avatar({ url, name = "", size = "h-8 w-8", text = "text-xs", className = "", testid }) {
  return url ? (
    <img data-testid={testid} src={imgSrc(url)} alt={name} className={`${size} rounded-full object-cover shrink-0 ${className}`} />
  ) : (
    <span data-testid={testid} className={`${size} ${text} rounded-full bg-[#FF3B6B] grid place-items-center font-bold shrink-0 ${className}`}>{(name || "?")[0]}</span>
  );
}
